export const ASOS_WORLD_LOCALIZED_PATHS = {
  COM: "discover/asos-world/",
  DE: "entdecken/asos-world/",
  US: "discover/asos-world/",
};

export const getAsosWorldUrl = (storeCode) =>
  ASOS_WORLD_LOCALIZED_PATHS[storeCode || "COM"] ||
  ASOS_WORLD_LOCALIZED_PATHS.COM;
